import { useEffect, useState } from 'react'
import axios from 'axios'

const useProductCollection = (apiUrl, companyId, accessToken) => {
  const [productCollection, setProductCollection] = useState(null)
  const [isLoading, setIsLoading] = useState(true)
  const [error, setError] = useState(null)

  useEffect(() => {
    const getProductCollection = async () => {
      const url = `${apiUrl}/FinancialManagement/Company/${companyId}/Nordania/ProductCollection`

      try {
        setIsLoading(true)

        const response = await axios.get(url, {
          headers: {
            'Authorization': `Bearer ${accessToken}`
          }
        })

        setProductCollection(response.data)
      } catch (error) {
        console.error('HTTP Error:', error.message)
        setError(error)
      } finally {
        setIsLoading(false)
      }
    }

    getProductCollection()
  }, [companyId, accessToken])

  return {
    productCollection,
    productCollectionIsLoading: isLoading,
    productCollectionError: error
  }
}

export default useProductCollection
